"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inviteLeadProxy = void 0;
const core_1 = require("@zodios/core");
const zod_1 = require("zod");
exports.inviteLeadProxy = (0, core_1.makeEndpoint)({
    method: "get",
    path: "/site/invite-proxy/:campaign?",
    alias: "inviteLeadProxy",
    parameters: [
        {
            name: "campaign",
            type: "Path",
            schema: zod_1.z.string(),
        },
        {
            name: "utm_source",
            type: "Query",
            schema: zod_1.z.string().optional(),
        },
        {
            name: "utm_medium",
            type: "Query",
            schema: zod_1.z.string().optional(),
        },
        {
            name: "utm_campaign",
            type: "Query",
            schema: zod_1.z.string().optional(),
        },
        {
            name: "utm_term",
            type: "Query",
            schema: zod_1.z.string().optional(),
        },
        {
            name: "_fbp",
            type: "Query",
            schema: zod_1.z.string().optional(),
        },
        {
            name: "_ttp",
            type: "Query",
            schema: zod_1.z.string().optional(),
        },
        {
            name: "externalAnalyticsId",
            type: "Query",
            schema: zod_1.z.string().optional(),
        },
        {
            name: "domainReferrer",
            type: "Query",
            schema: zod_1.z.string().optional(),
        },
    ],
    response: zod_1.z.object({
        _redirect: zod_1.z.string(),
    }),
});
//# sourceMappingURL=invite.js.map